import { CHART_ALL_FEEDBACK_ALIAS } from '@/entities/chart/model/constants';
import chartUtils from '@/features/(charts)/chart-renderer/lib/chart-utils';
import type { DataBuilderParams, TotalsMap } from '@/features/(charts)/chart-renderer/ui/Cross/types';

/**
 * DataSource 생성을 위한 베이스 클래스
 * 모든 DataSourceGenerator는 이 클래스를 상속받아 구현
 */
export abstract class DataSourceGenerator {
  protected params: DataBuilderParams;

  constructor(params: DataBuilderParams) {
    this.params = params;
  }

  /**
   * 데이터 소스를 생성하는 추상 메서드
   * 각 하위 클래스에서 구현해야 함
   */
  abstract buildDataSource(): Record<string, StringNumberValue | null>[];

  /**
   * yHeaders 기반 total 맵 계산
   *
   * @param tableData - 테이블 데이터
   * @param yHeaders - y축 헤더 목록
   * @param sortedCandidates - 정렬된 x축 후보 목록
   * @returns Total 맵
   */
  protected calculateTotals(
    tableData: ChartCrossTableData,
    yHeaders: StringNumberValue[],
    sortedCandidates: StringNumberValue[],
    isFeedbackAll: boolean = false,
  ): TotalsMap {
    const yTotalMap = chartUtils.getKeyValueMapByKeys(yHeaders);
    const xTotalMap = chartUtils.getKeyValueMapByKeys(sortedCandidates);
    let grandTotal = 0;

    tableData.forEach((x) => {
      x.values.forEach((y) => {
        if (isFeedbackAll) {
          yTotalMap[CHART_ALL_FEEDBACK_ALIAS] += y.value;
          xTotalMap[x.x] += y.value;
          grandTotal += y.value;
        } else {
          yTotalMap[y.y] += y.value;
          xTotalMap[x.x] += y.value;
          grandTotal += y.value;
        }
      });
    });

    return {
      yTotalMap,
      xTotalMap,
      grandTotal,
    };
  }
}
